import {
  Avatar,
  AvatarGroup,
  Directory,
  DirectoryRow,
  Pushtext
} from '@stratumn/atomic';

import graphql from 'babel-plugin-relay/macro';
import { ROUTE_TEAM } from 'constant/routes';
import compose from 'lodash.flowright';
import PropType from 'prop-types';
import React from 'react';
import injectSheet from 'react-jss';
import { createFragmentContainer } from 'react-relay';
import { generatePath, withRouter } from 'react-router-dom';
import nameToInitials from 'utils/nameToInitials';
import { withGqlClient } from 'wrappers';

import styles from './member.style';
import RemoveOrgMemberModal from './removeOrgMemberModal';
import RemoveTeamMemberModal from './removeTeamMemberModal';

const INITIAL_STATE = {
  teamRowId: '',

  showModalTeam: false,
  showModalOrg: false
};

export class Member extends React.Component {
  static propTypes = {
    classes: PropType.object.isRequired,
    history: PropType.object.isRequired,
    member: PropType.object.isRequired
  };

  state = INITIAL_STATE;

  toggleModalOrg = () =>
    this.setState({
      showModalOrg: !this.state.showModalOrg
    });

  toggleModalTeam = teamRowId =>
    this.setState({
      teamRowId,
      showModalTeam: !this.state.showModalTeam
    });

  renderTeamRow = (node, index) => {
    const { id, rowId, name, avatar, canUpdate } = node;
    const {
      history,
      match: { params },
      classes,
      member: {
        teams: { totalCount }
      }
    } = this.props;

    return (
      <DirectoryRow
        cell1={
          canUpdate && (
            <Pushtext
              data-testid="remove-team-member"
              onClick={() => this.toggleModalTeam(rowId)}
            >
              Remove
            </Pushtext>
          )
        }
        isLast={index === totalCount - 1}
        key={id}
        main={
          <Pushtext
            data-testid="team-link"
            onClick={() =>
              history.push(
                generatePath(ROUTE_TEAM, {
                  id: rowId,
                  orgId: params.orgId
                })
              )
            }
          >
            <div className={classes.link}>
              <AvatarGroup
                initials={nameToInitials(name)}
                nth={Number(rowId)}
                size={37}
                src={avatar}
              />
              <span className={classes.teamName}>{name}</span>
            </div>
          </Pushtext>
        }
      />
    );
  };

  render() {
    const {
      classes,
      member,
      member: {
        organizations: {
          nodes: [organization]
        }
      }
    } = this.props;
    const {
      account: {
        members: {
          nodes: [is]
        }
      }
    } = organization;
    const { showModalTeam, showModalOrg, teamRowId } = this.state;

    return (
      <>
        <div className={classes.userHeaderWrapper}>
          <div>
            <Avatar size={56} src={member.avatar} />
            <div className={classes.userName}>{member.name}</div>
            <div className={classes.userRole}>
              {is.admin ? 'Admin' : 'Participant'}
            </div>
          </div>
          <div>
            {organization.canUpdate && (
              <Pushtext mute onClick={this.toggleModalOrg} warning>
                Remove from organization...
              </Pushtext>
            )}
          </div>
        </div>
        <div className={classes.collectionItem}>
          <div className={classes.collectionItemLabel}>email</div>
          <div className={classes.collectionItemValue}>{member.email}</div>
        </div>
        {showModalTeam && (
          <RemoveTeamMemberModal
            memberRowId={member.rowId}
            teamRowId={teamRowId}
            toggleModal={this.toggleModalTeam}
          />
        )}
        {showModalOrg && (
          <RemoveOrgMemberModal
            memberRowId={member.rowId}
            organizationRowId={organization.rowId}
            toggleModal={this.toggleModalOrg}
          />
        )}
        <Directory columnTitle="teams" showColumnTitles>
          {member.teams.nodes.map((index, node) =>
            this.renderTeamRow(index, node)
          )}
        </Directory>
      </>
    );
  }
}

export default createFragmentContainer(
  compose(withRouter, withGqlClient, injectSheet(styles))(Member),
  {
    member: graphql`
      fragment member_member on User
      @argumentDefinitions(
        organizationFilter: { type: "OrganizationFilter", defaultValue: {} }
        memberFilter: { type: "MemberFilter", defaultValue: {} }
        teamFilter: { type: "TeamFilter", defaultValue: {} }
      ) {
        ...removeOrgMemberModal_member
          @arguments(
            organizationFilter: $organizationFilter
            teamFilter: $teamFilter
          )
        ...removeTeamMemberModal_member @arguments(teamFilter: $teamFilter)
        id
        rowId
        name
        email
        avatar
        canUpdate
        organizations(filter: $organizationFilter) {
          nodes {
            rowId
            canUpdate
            account {
              members(filter: $memberFilter) {
                nodes {
                  admin
                }
              }
            }
          }
        }
        teams(filter: $teamFilter) {
          totalCount
          nodes {
            id
            rowId
            name
            avatar
            canUpdate
          }
        }
      }
    `
  }
);
